import { Input, Label, Tooltip } from '@iwoca/orion';
import { Trans, useLingui } from '@lingui/react/macro';
import { clsx } from 'clsx';
import { useFormContext } from 'react-hook-form';

import styles from './CompanyInputManualDE.module.css';
import CompanyLegalFormDE from './CompanyLegalFormDE';
import { useIsInDECompanySearchUITest } from '../../../../../hooks/useIsInDECompanySearchUITest';
import ButtonLink from '../../../../ButtonLink/ButtonLink';
import { TCompanyDetailsDataDE } from '../../CompanyDetailsDE';

type TProps = {
  setManualInputFalse: () => void;
};

const CompanyInputManualDE = ({ setManualInputFalse }: TProps) => {
  const { t } = useLingui();

  const { isIncludedInCompanySearchUITest } = useIsInDECompanySearchUITest();

  const {
    register,
    formState: { errors },
  } = useFormContext<TCompanyDetailsDataDE>();

  return (
    <>
      <div className={styles.formFieldGroup}>
        <div>
          <div className={clsx(styles.formLabel, styles.companyNameLabel)}>
            <div className={styles.labelWithTooltip}>
              <Label htmlFor="companyName">
                {isIncludedInCompanySearchUITest ? (
                  <Trans>Business name search</Trans>
                ) : (
                  <Trans>Limited company</Trans>
                )}
              </Label>
              <Tooltip
                data-testid="manual-input-tooltip"
                content={
                  isIncludedInCompanySearchUITest
                    ? t`Enter your business details manually here.`
                    : t`Enter your company details manually here.`
                }
              />
            </div>

            <ButtonLink
              className={styles.searchCompany}
              type="button"
              onClick={setManualInputFalse}
            >
              {isIncludedInCompanySearchUITest ? (
                <Trans>Go back to search your business</Trans>
              ) : (
                <Trans>Go back to search your company</Trans>
              )}
            </ButtonLink>
          </div>
          <Input
            {...register('companyName')}
            id="companyName"
            error={errors.companyName?.message}
            className="fs-mask"
            placeholder={t`e.g. Company Name`}
          />
        </div>
      </div>
      <div className={styles.formFieldGroup}>
        <div className={styles.formFieldStreet}>
          <Input
            {...register('street')}
            placeholder={t`e.g. Street`}
            label={t`Street`}
            error={errors.street?.message}
            className="fs-mask"
          />
        </div>
        <div>
          <Input
            {...register('buildingNumber')}
            placeholder={t`e.g. 21`}
            label={t`House number`}
            error={errors.buildingNumber?.message}
            className="fs-mask"
          />
        </div>
      </div>
      <div className={styles.formFieldGroup}>
        <div className={styles.formFieldPostcode}>
          <Input
            {...register('postcode')}
            placeholder={t`e.g. 37269`}
            label={t`Postcode`}
            error={errors.postcode?.message}
            className="fs-mask"
          />
        </div>
        <Input
          {...register('town')}
          placeholder={t`e.g. London`}
          label={t`Town`}
          error={errors.town?.message}
          className="fs-mask"
        />
      </div>
      <CompanyLegalFormDE />
    </>
  );
};

export default CompanyInputManualDE;
